import apiClient from './apiClient';

// ========== Booking Configuration ==========

export type BookingMode = 'OPEN' | 'APPROVAL_REQUIRED' | 'PRIVATE';

export interface SalonBookingConfigResponse {
    id: string;
    salonId: string;
    bookingMode: BookingMode;
    requirePhoneVerification: boolean;
    requireDeposit: boolean;
    depositAmount: number | null;
    depositEnabledServices: string[] | null;
    maxBookingsPerHour: number;
    maxBookingsPerDay: number;
    showPricing: boolean;
    showEmployeeFullNames: boolean;
    bookingWindowDays: number;
    vipModeEnabled: boolean;
    vipAccessCode: string | null;
}

export interface SalonBookingConfigRequest {
    bookingMode: BookingMode;
    requirePhoneVerification: boolean;
    requireDeposit: boolean;
    depositAmount: number | null;
    depositEnabledServices: string[] | null;
    maxBookingsPerHour: number;
    maxBookingsPerDay: number;
    showPricing: boolean;
    showEmployeeFullNames: boolean;
    bookingWindowDays: number;
    vipModeEnabled: boolean;
    vipAccessCode: string | null;
}

// ========== Booking Approval ==========

export type ApprovalAction = 'APPROVE' | 'REJECT';

export interface BookingApprovalRequest {
    action: ApprovalAction;
    rejectReason?: string;
}

export interface PendingBooking {
    id: string;
    salonId: string;
    employeeId: string;
    serviceId: string;
    clientId: string;
    clientName: string;
    clientPhone: string;
    startTime: string;
    endTime: string;
    status: string;
    approvalStatus: string;
    source: string;
    phoneVerified: boolean;
    createdAt: string;
}

export const bookingSecurityApi = {
    // ========== Configuration ==========

    getConfig: async (salonId: string): Promise<SalonBookingConfigResponse> => {
        const response = await apiClient.get<SalonBookingConfigResponse>(
            `/salon/booking-config/${salonId}`
        );
        return response.data;
    },

    updateConfig: async (salonId: string, data: SalonBookingConfigRequest): Promise<SalonBookingConfigResponse> => {
        const response = await apiClient.put<SalonBookingConfigResponse>(
            `/salon/booking-config/${salonId}`,
            data
        );
        return response.data;
    },

    // ========== Approval ==========

    getPendingBookings: async (salonId: string): Promise<PendingBooking[]> => {
        const response = await apiClient.get<PendingBooking[]>(
            `/salon/booking-approval/${salonId}/pending`
        );
        return response.data;
    },

    makeDecision: async (bookingId: string, data: BookingApprovalRequest): Promise<void> => {
        await apiClient.post(`/salon/booking-approval/${bookingId}`, data);
    },
};
